export const mainChatSteps = [
  {
    target: '[data-tour="welcome-text"]',
    content: {
      title: "Welcome to ACE!",
      body: "This is your AI-powered chat assistant. Let us show you around so you can get the most out of it.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="data-source-select"]',
    content: {
      title: "Choose Your Data Source",
      body: "Pick from Collections, Databases, or Web URLs to start chatting with your data.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="chat-sidebar"]',
    content: {
      title: "Chat History",
      body: "All your past conversations live here. Click any session to pick up where you left off, or start a fresh chat.",
    },
    placement: "right",
    disableBeacon: true,
    spotlightClicks: false,
    data: { action: "openSidebar" },
  },
  {
    target: '[data-tour="quick-chat-pinned-row"]',
    content: {
      title: "New: Quick chat",
      body: "Need a fast answer that won't get saved? Quick chat skips the RAG pipeline for one-off questions. Nothing is stored to your history or on the server.",
    },
    placement: "right",
    disableBeacon: true,
    spotlightClicks: false,
    // The tour itself introduces the feature — mark the intro callout / dot
    // as seen so the user isn't shown the same hint twice.
    data: { action: "markQuickChatIntroSeen" },
  },
  {
    target: '[data-tour="nav-collections-link"]',
    content: {
      title: "Collections",
      body: "Create and manage your knowledge bases here. Upload documents, add URLs, or connect databases.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
    data: { action: "closeSidebar" },
  },
  {
    target: '[data-tour="nav-management-link"]',
    content: {
      title: "Management",
      body: "Manage users and permissions for your organisation from here.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="nav-settings-link"]',
    content: {
      title: "Settings",
      body: "Customize how ACE responds — adjust response length, creativity, crawl depth, and streaming preferences.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="nav-profile-link"]',
    content: {
      title: "Profile",
      body: "View your account details and sign out. That's the tour — happy exploring!",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
];

export const collectionManagementSteps = [
  {
    target: '[data-tour="cm-header"]',
    content: {
      title: "Welcome to Collections!",
      body: "Collections are knowledge bases that ACE searches when you chat. Upload PDFs, Word docs, text files, spreadsheets, and more to build your searchable data.",
    },
    placement: "center",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="cm-add-button"]',
    content: {
      title: "Create Something New",
      body: 'Click "+ Add" to create a collection or connect a database. Collections can be Private (only you) or Public (visible to your whole organisation).',
    },
    placement: "bottom-end",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="cm-search-bar"]',
    content: {
      title: "Find Collections Fast",
      body: "Use the search bar to find collections by name. Filter by public or private, and sort by name or date.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="cm-collection-list"]',
    content: {
      title: "Your Collections",
      body: "Your collections appear here. View details, update documents, share with teammates, or delete them. You're all set!",
    },
    placement: "auto",
    disableBeacon: true,
    spotlightClicks: false,
    data: { compact: true },
  },
];

export const userManagementSteps = [
  {
    target: '[data-tour="um-header"]',
    content: {
      title: "User Management",
      body: "This is where you manage users in your tenancy. You can add, edit roles, or remove users from your organisation.",
    },
    placement: "center",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="um-add-button"]',
    content: {
      title: "Add a User",
      body: "Click here to invite a new user. You'll enter their name, email, department, and assign a role (User, Tenant Admin, or System Admin).",
    },
    placement: "bottom-end",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="um-search-bar"]',
    content: {
      title: "Search Users",
      body: "Quickly find a user by typing their name here.",
    },
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
  },
  {
    target: '[data-tour="um-user-list"]',
    content: {
      title: "Your Users",
      body: "Your tenancy's users will appear here. Click the edit button to change a user's role, or the delete button to remove them.",
    },
    placement: "top",
    disableBeacon: true,
    spotlightClicks: false,
  },
];
